module.exports = __webpack_public_path__ + "assets/src/style/img/svg/icons/category-film.svg?b04bbbdf8038b44fd334a44eb818222e";